
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000C1F","fill-opacity":".8"}},[_c('path',{attrs:{"d":"M6 11.932A6 6 0 011.756 1.69a6 6 0 018.484 8.484A5.96 5.96 0 016 11.932zM6 .635A5.303 5.303 0 00.701 5.932 5.303 5.303 0 006 11.23a5.303 5.303 0 005.297-5.297A5.303 5.303 0 005.999.635z"}}),_c('path',{attrs:{"d":"M4.59 9.34h-.886a1.233 1.233 0 01-1.231-1.232v-1.77a1.233 1.233 0 011.231-1.232h.885a.352.352 0 01.352.352v3.53a.352.352 0 01-.352.352zm-.886-3.53a.53.53 0 00-.528.528v1.77a.53.53 0 00.528.529h.534V5.81h-.534z"}}),_c('path',{attrs:{"d":"M7.64 9.34H4.59a.352.352 0 01-.352-.352v-3.53a.35.35 0 01.029-.138l.937-2.194a1.067 1.067 0 011.426-.493 1.062 1.062 0 01.492 1.405l-.263.715h1.01a1.662 1.662 0 011.635 1.96l-.23 1.262A1.662 1.662 0 017.64 9.34zM4.94 8.637H7.64a.958.958 0 00.943-.788l.23-1.262a.959.959 0 00-.943-1.13H6.355a.352.352 0 01-.33-.473l.443-1.204a.366.366 0 01.014-.035.359.359 0 00-.638-.33L4.941 5.53v3.107z"}})])])
          )
        }
      }
    